class QueryHelper {
	static GetParameterString(params) {
		if (params) {
			let esc = encodeURIComponent;
			let query = Object.keys(params)
				.map(k => esc(k) + `=` + esc(params[k]))
				.join(`&`);

			return `?${query}`;
		}
		return ``;
	}

	static BuildHeaders({ lc, brand, nmscConfig } = {}) {
		const headers = {};
		lc && (headers[`X-TME-LC`] = lc);
		brand && (headers[`X-TME-BRAND`] = brand);
		nmscConfig && (headers[`X-TME-NMSC`] = nmscConfig);

		return headers;
	}
}
module.exports = QueryHelper;
